export const openNewTab = (href: string) => {
  const anchor = document.createElement('a');
  anchor.target = '_blank';
  anchor.href = href;
  anchor.rel = 'noopener noreferrer';

  anchor.click();
}
